import { SVGProps } from 'react';

const Pipette = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414m0 0A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12M2.414 21.586 2 22M18 9l.4.4a2.121 2.121 0 1 1-3 3l-3.8-3.8a2.121 2.121 0 0 1 3-3l.4.4 3.4-3.4a2.121 2.121 0 1 1 3 3z"
    />
  </svg>
);
export default Pipette;
